type Props = {
  src: string;
  alt: string;
};

/**
 * Real dark-mode screenshot of the Orthodox Way mobile app, rendered to
 * fill the phone-variant DeviceFrame interior. Used inside <DeviceFrame
 * variant="phone"> on the landing page.
 */
export function PhoneShot({ src, alt }: Props) {
  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      className="block w-full h-full"
      style={{ objectFit: 'cover', objectPosition: 'center top' }}
    />
  );
}
